(() => {
  const DESKTOP_BREAKPOINT = '(min-width: 990px)';
  const desktopMedia = window.matchMedia(DESKTOP_BREAKPOINT);

  function getMenus() {
    return Array.from(document.querySelectorAll('header-menu details.mega-menu'));
  }

  function closeMenu(menu) {
    if (!menu || !menu.hasAttribute('open')) return;

    menu.removeAttribute('open');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  function openMenu(menu) {
    if (!menu || !desktopMedia.matches) return;

    getMenus().forEach((candidate) => {
      if (candidate !== menu) closeMenu(candidate);
    });

    menu.setAttribute('open', '');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  function bindMenu(menu) {
    if (!menu || menu.dataset.eliteHoverBound === 'true') return;
    menu.dataset.eliteHoverBound = 'true';

    const summary = menu.querySelector('summary');
    let closeTimer;

    const clearCloseTimer = () => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const queueClose = () => {
      clearCloseTimer();
      closeTimer = window.setTimeout(() => closeMenu(menu), 140);
    };

    const handleEnter = () => {
      if (!desktopMedia.matches) return;
      clearCloseTimer();
      openMenu(menu);
    };

    summary?.addEventListener('mouseenter', handleEnter);
    summary?.addEventListener('focus', handleEnter);
    menu.addEventListener('mouseenter', handleEnter);
    menu.addEventListener('mouseleave', () => {
      if (!desktopMedia.matches) return;
      queueClose();
    });

    menu.addEventListener('focusout', () => {
      if (!desktopMedia.matches) return;

      window.requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) closeMenu(menu);
      });
    });

    summary?.addEventListener('click', (event) => {
      if (!desktopMedia.matches) return;

      event.preventDefault();

      if (menu.hasAttribute('open')) {
        closeMenu(menu);
      } else {
        openMenu(menu);
      }
    });
  }

  function init() {
    getMenus().forEach(bindMenu);

    const params = new URLSearchParams(window.location.search);
    if (desktopMedia.matches && (params.has('navPreview') || params.has('nav-preview'))) {
      openMenu(getMenus()[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  desktopMedia.addEventListener?.('change', (event) => {
    if (!event.matches) {
      getMenus().forEach(closeMenu);
    }
  });
})();
